import { FaXmark } from "react-icons/fa6"

export default function Launcher({ isOpen, launcherOpenImg, launcherCloseImg, onClick }) {
  const showClose = isOpen && !launcherCloseImg
  const img = isOpen ? launcherCloseImg : launcherOpenImg

  return (
    <button type="button" className="chatbot-widget-launcher rcw-launcher" onClick={onClick}>
      {showClose ? <FaXmark /> : img ? <img src={img} alt="" /> : null}
    </button>
  )
}
